export const GET_ASK_QUESTIONS_REQUEST = "GET_ASK_QUESTIONS_REQUEST";
export const GET_ASK_QUESTIONS_SUCCESS = "GET_ASK_QUESTIONS_SUCCESS";
export const GET_ASK_QUESTIONS_FAILURE = "GET_ASK_QUESTIONS_FAILURE";

export const POST_ASK_QUESTIONS_REQUEST = "POST_ASK_QUESTIONS_REQUEST";
export const POST_ASK_QUESTIONS_SUCCESS = "POST_ASK_QUESTIONS_SUCCESS";
export const POST_ASK_QUESTIONS_FAILURE = "POST_ASK_QUESTIONS_FAILURE";

export const UPDATE_RECOMMENDATION_REQUEST = " UPDATE_RECOMMENDATION_REQUEST";
export const UPDATE_RECOMMENDATION_SUCCESS = " UPDATE_RECOMMENDATION_SUCCESS";
export const UPDATE_RECOMMENDATION_FAILURE = " UPDATE_RECOMMENDATION_FAILURE";

export const POST_ASK_QUESTION_COMMENT_REQUEST =
  "POST_ASK_QUESTION_COMMENT_REQUEST";
export const POST_ASK_QUESTION_COMMENT_SUCCESS =
  "POST_ASK_QUESTION_COMMENT_SUCCESS";
export const POST_ASK_QUESTION_COMMENT_FAILURE =
  "POST_ASK_QUESTION_COMMENT_FAILURE";

export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";
